import { render, staticRenderFns } from "./OrderResultList.vue?vue&type=template&id=e9b73c88&"
import script from "./OrderResultList.vue?vue&type=script&lang=ts&"
export * from "./OrderResultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports